import QuagganEmoji from "./QuagganEmoji.jsx";
import GoldCoin from "../images/Gold_coin.png";
import SilverCoin from "../images/Silver_coin.png";
import CopperCoin from "../images/Copper_coin.png";
import { copperToCoinParts } from "../utils/coins";

const coinByRank = {
  1: GoldCoin,
  2: SilverCoin,
  3: CopperCoin,
};

const podiumStyleByRank = {
  1: {
    pedestalHeight: 126,
    pedestalColor: "linear-gradient(180deg, rgba(240,190,70,0.92), rgba(144,104,12,0.95))",
    border: "1px solid rgba(255, 221, 140, 0.65)",
  },
  2: {
    pedestalHeight: 98,
    pedestalColor: "linear-gradient(180deg, rgba(192,208,224,0.9), rgba(90,108,128,0.95))",
    border: "1px solid rgba(216, 230, 255, 0.6)",
  },
  3: {
    pedestalHeight: 80,
    pedestalColor: "linear-gradient(180deg, rgba(198,126,84,0.9), rgba(110,60,28,0.96))",
    border: "1px solid rgba(230, 170, 130, 0.55)",
  },
};

export default function QuagganPodium({ podiumRows, podiumSeedNonce }) {
  return (
    <div
      style={{
        marginBottom: 16,
        borderRadius: 18,
        padding: 14,
        background: "linear-gradient(180deg, rgba(8, 24, 50, 0.92), rgba(5, 16, 34, 0.88))",
        border: "1px solid rgba(80, 180, 255, 0.24)",
      }}
    >
      <div style={{ fontWeight: 700, color: "#90e0ef", marginBottom: 10 }}>Top Winners Podium</div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          alignItems: "end",
          gap: "clamp(4px, 1.8vw, 10px)",
        }}
      >
        {podiumRows.map((row) => {
          const rankStyles = podiumStyleByRank[row.rank] || podiumStyleByRank[3];
          const { gold, silver, copper } = copperToCoinParts(row.totalValue || 0);

          return (
            <div key={row.key} style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 0 }}>
              <div style={{ position: "relative", marginBottom: 6 }}>
                <QuagganEmoji type="success" seed={`podium-${row.key}-${podiumSeedNonce}`} size={74} />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  fontSize: 16,
                  fontWeight: 800,
                  color: "#e8f8ff",
                  textAlign: "center",
                  lineHeight: 1.2,
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={row.name}
              >
                {coinByRank[row.rank] ? (
                  <img
                    src={coinByRank[row.rank]}
                    alt=""
                    style={{ width: 22, height: 22, objectFit: "contain", flexShrink: 0 }}
                  />
                ) : null}
                {row.name}
              </div>
              <div
                style={{
                  marginTop: 8,
                  width: "100%",
                  maxWidth: 220,
                  height: rankStyles.pedestalHeight,
                  borderRadius: "12px 12px 0 0",
                  background: rankStyles.pedestalColor,
                  border: rankStyles.border,
                  borderBottom: "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  boxShadow: "0 10px 18px rgba(0, 0, 0, 0.28)",
                }}
              >
                <div style={{ fontSize: 36, fontWeight: 900, color: "rgba(255,255,255,0.85)", lineHeight: 1 }}>
                  {row.rank}
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "rgba(255,255,255,0.95)" }}>
                  {row.wins} total wins
                </div>
                <div className="podium-value-wrap">
                  <div className="podium-value-desktop">
                    <span className="podium-value-label">Value</span>
                    <span className="podium-value-coin-unit">
                      <span>{gold}</span>
                      <img src={GoldCoin} alt="gold" />
                    </span>
                    <span className="podium-value-coin-unit">
                      <span>{silver}</span>
                      <img src={SilverCoin} alt="silver" />
                    </span>
                    <span className="podium-value-coin-unit">
                      <span>{copper}</span>
                      <img src={CopperCoin} alt="copper" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
